// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum PropertyFilterType {
  Exists = 0,
  NotExists = 1,
  Equals = 2,
  NotEquals = 3,
  StartsWith = 4,
  Contains = 5,
  NotContains = 6,
  GreaterThan = 7,
  LessThan = 8
}
